// extracted by mini-css-extract-plugin
module.exports = {"container":"Posts-module--container--2n6Y4","item":"Posts-module--item--JtyvC","title":"Posts-module--title--1z3So"};